import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Factura } from 'src/app/Models/factura/factura';
import { Personal } from 'src/app/Models/personal/personal';
import { DataService } from 'src/app/Service/data.service';

@Component({
  selector: 'app-change-personal',
  templateUrl: './change-personal.component.html',
  styleUrls: ['./change-personal.component.css']
})
export class ChangePersonalComponent implements OnInit {

  pedido: Factura = new Factura();

  public listapersonal: Personal[] = [];
  constructor(public activeModal: NgbActiveModal, private data: DataService) {
  
  }

  ngOnInit() {
    // ngOnInit: los datos YA están asignados    
    this.getlistaPersonal();
  }

  getlistaPersonal() {
    this.data.GetSimple(this.data.api.personal).subscribe((r) => {
      console.log("Personal obtenido", r);
      
      this.listapersonal = r
    })
  }

  cerrar() {
    this.activeModal.dismiss('cancelado');
  }

  guardar() {
    const payload = { idvende: this.pedido.idvende };

    this.data.Patch(this.data.api.factura, this.pedido.idfactura.toString(), payload).subscribe(
      (res) => { 
        if (res.status == 'success') {
          this.data.notify("Vendedor modificado correctamente", "Éxito", this.data.alertType.success)
          this.activeModal.close('modificado');
        }
      },
      (error) => {
        this.data.notify("Error al modificar el vendedor", "Error", this.data.alertType.error)
       });
    
  }
}
